import React from 'react';

import LicenseView from './View';

const License = ({ license, onEdit }) => {
  return <LicenseView license={license} onEdit={onEdit} />;
};

export default License;
